import "onsenui/css/onsenui.css";
import "onsenui/css/onsen-css-components.min.css";
import "../css.css";
import { registerSW } from "virtual:pwa-register";
import { Ticket } from "./Ticket";

let ticket: Ticket | null = null;

(async () => {
  ticket = await Ticket.create("krakow", "24h");
  console.log("Initial ticket created:", ticket);
})();

setInterval(() => {
  if (ticket) {
    ticket.printTimeLeft();
  }
}, 1000);

document.addEventListener("init", function (event: Event) {
  const page = event.target as HTMLElement;

  if (page.matches("#MojeBilety")) {
    if (ticket) {
      ticket.updateDOM();
    }

    const refreshBtn = document.getElementById("refresh_button");
    if (refreshBtn) {
      let refreshClickCount = 0;
      let refreshTimer: number = 0;

      refreshBtn.onclick = function () {
        refreshClickCount++;
        window.clearTimeout(refreshTimer);

        if (refreshClickCount >= 4) {
          refreshClickCount = 0;
          if (ticket) {
            ticket.changeSideNumberWithPrompt();
            ticket.changeSecurityCode();
          }
        } else {
          refreshTimer = window.setTimeout(() => {
            refreshClickCount = 0;
          }, 500);
        }
      };
    }

    const prolongBtn = document.getElementById("prolong_ticket_button");
    if (prolongBtn) {
      prolongBtn.onclick = function () {
        // Prolong ticket handler
      };
    }

    const showDetailsBtn = document.querySelector(".show_details_button") as HTMLElement | null;
    if (showDetailsBtn) {
      showDetailsBtn.onclick = function () {
        biletFull();
      };
    }

    const hideDetailsBtn = document.querySelector(".hide_details_button") as HTMLElement | null;
    if (hideDetailsBtn) {
      hideDetailsBtn.onclick = function () {
        biletSummary();
      };
    }
  }
});

document.addEventListener("show", function (event: Event) {
  const page = event.target as HTMLElement;

  if (page.matches("#MojeBilety")) {
    if (ticket) {
      ticket.updateDOM();
    }
  }

  if (page.matches("#Ulubione")) {
    let currentFruitId = ticket ? ticket.id : "";
    const radios = document.querySelectorAll(".radio-fruit");

    radios.forEach((radio) => {
      radio.addEventListener("change", function (e: Event) {
        const target = e.target as HTMLInputElement;
        if (target.id !== currentFruitId) {
          const parts = target.id.split("-");
          const selectedCity = parts[0];
          const selectedTicket = parts[1];

          console.log("selectedCity", selectedCity);
          console.log("selectedTicket", selectedTicket);

          ticket = null;
          (async () => {
            ticket = await Ticket.create(selectedCity, selectedTicket);
            console.log(ticket);
            console.log(ticket.label);

            const selectedCityEl = document.getElementById("selectedCity");
            if (selectedCityEl) {
              selectedCityEl.innerHTML = `Wybrane miasto:&nbsp;<strong style="text-transform: capitalize;"> ${ticket.miasto} </strong>`;
            }

            const selectedTicketEl = document.getElementById("selectedTicket");
            if (selectedTicketEl) {
              selectedTicketEl.innerHTML = `${ticket.label}`;
            }
          })();

          const prevRadio = document.getElementById(currentFruitId) as HTMLInputElement | null;
          if (prevRadio) {
            prevRadio.checked = false;
          }
          currentFruitId = target.id;
        }
      });
    });
  }
});

function biletFull(): void {
  const bilet = document.querySelector("article.bilet");
  if (bilet) {
    bilet.classList.remove("summary");
    bilet.classList.add("full");
  }
}

function biletSummary(): void {
  const bilet = document.querySelector("article.bilet");
  if (bilet) {
    bilet.classList.add("summary");
    bilet.classList.remove("full");
  }
}

declare class Html5Qrcode {
  constructor(elementId: string, config?: unknown);
  start(
    cameraScannerPreference: { facingMode: string } | string,
    configuration: { fps?: number; qrbox?: number | { width: number; height: number } },
    qrCodeSuccessCallback: (decodedText: string, result: unknown) => void,
    qrCodeErrorCallback?: (errorMessage: string) => void
  ): Promise<void>;
  stop(): Promise<void>;
  clear(): void;
}

let html5QrCodeScanner: Html5Qrcode | null = null;

function stopQrScanner(): void {
  const modal = document.getElementById("qr_scanner_modal");
  if (modal) {
    modal.classList.add("hide");
  }
  if (html5QrCodeScanner) {
    html5QrCodeScanner.stop().then(() => {
      html5QrCodeScanner?.clear();
      html5QrCodeScanner = null;
    }).catch((err) => {
      console.error("Error stopping QR scanner:", err);
      html5QrCodeScanner = null;
    });
  }
}

function startQrScanner(): void {
  const modal = document.getElementById("qr_scanner_modal");
  if (!modal) return;

  modal.classList.remove("hide");

  if (!html5QrCodeScanner) {
    html5QrCodeScanner = new Html5Qrcode("qr_reader_container");
  }

  const config = { fps: 10, qrbox: { width: 250, height: 250 } };

  html5QrCodeScanner.start(
    { facingMode: "environment" },
    config,
    (decodedText: string) => {
      console.log("QR decoded:", decodedText);

      // Zapis do localStorage i pola #numerBoczny
      localStorage.setItem("numerBoczny", decodedText);

      if (ticket) {
        ticket.setSideNumber(decodedText);
      } else {
        const sideNumberEl = document.getElementById("numerBoczny");
        if (sideNumberEl) {
          sideNumberEl.innerText = decodedText;
        }
      }

      stopQrScanner();
    },
    (errorMessage: string) => {
      // Ignorowanie drobnych błędów braku ramki QR
    }
  ).catch((err: unknown) => {
    console.error("Nie udało się uruchomić kamery:", err);
    alert("Nie można uruchomić kamery skanera QR: " + err);
    stopQrScanner();
  });
}

document.addEventListener("click", function (event: Event) {
  const target = event.target as HTMLElement | null;
  if (!target) return;

  if (target.id === "scan_qr_button" || target.closest("#scan_qr_button")) {
    startQrScanner();
  }

  if (target.id === "close_qr_modal" || target.closest("#close_qr_modal") || target.id === "qr_scanner_modal") {
    stopQrScanner();
  }

  if (target.id === "toggle_discount_button" || target.closest("#toggle_discount_button")) {
    if (ticket) {
      ticket.pokazZnizke = !ticket.pokazZnizke;
      ticket.updateDOM();
    } else {
      document.querySelectorAll(".discount").forEach((el) => {
        el.classList.toggle("hide");
      });
    }
  }
});

// Obsługa 4-krotnego szybkiego kliknięcia na kod QR (zmienianie obrazka qr1.png / qr2.png)
let qrClickCount = 0;
let qrClickTimer = 0;

document.addEventListener("click", function (event: Event) {
  const target = event.target as HTMLElement | null;
  if (!target) return;

  const qrContainer = target.closest(".qr_code") as HTMLElement | null;
  if (!qrContainer) return;

  qrClickCount++;
  window.clearTimeout(qrClickTimer);

  if (qrClickCount >= 4) {
    qrClickCount = 0;
    const imgEl = qrContainer.querySelector("img") as HTMLImageElement | null;
    if (imgEl) {
      if (imgEl.src.includes("qr2.png")) {
        imgEl.src = "/img/qr1.png";
        localStorage.setItem("selected_qr_image", "/img/qr1.png");
      } else {
        imgEl.src = "/img/qr2.png";
        localStorage.setItem("selected_qr_image", "/img/qr2.png");
      }
    }
  } else {
    qrClickTimer = window.setTimeout(() => {
      qrClickCount = 0;
    }, 500);
  }
});

// Przywrócenie wybranego kodu QR z localStorage przy załadowaniu/odświeżeniu
const savedQrImage = localStorage.getItem("selected_qr_image");
if (savedQrImage) {
  document.addEventListener("DOMContentLoaded", () => {
    const qrImg = document.querySelector(".qr_code img") as HTMLImageElement | null;
    if (qrImg) {
      qrImg.src = savedQrImage;
    }
  });
}

// Obsługa 4-krotnego szybkiego kliknięcia na pola <span>
const spanClickTracker = new Map<HTMLElement, { count: number; timer: number }>();

document.addEventListener("click", function (event: Event) {
  const target = event.target as HTMLElement | null;
  if (!target) return;

  const spanEl = target.closest("span") as HTMLElement | null;
  if (!spanEl) return;

  let clickData = spanClickTracker.get(spanEl);
  if (!clickData) {
    clickData = { count: 0, timer: 0 };
    spanClickTracker.set(spanEl, clickData);
  }

  clickData.count++;
  window.clearTimeout(clickData.timer);

  if (clickData.count >= 4) {
    clickData.count = 0;
    makeSpanEditable(spanEl);
  } else {
    clickData.timer = window.setTimeout(() => {
      if (clickData) {
        clickData.count = 0;
      }
    }, 500);
  }
});

function makeSpanEditable(el: HTMLElement): void {
  el.contentEditable = "true";
  el.focus();

  // Wyselekcjonowanie tekstu dla wygody edycji
  const range = document.createRange();
  range.selectNodeContents(el);
  const sel = window.getSelection();
  if (sel) {
    sel.removeAllRanges();
    sel.addRange(range);
  }

  const onBlur = () => {
    el.contentEditable = "false";
    el.removeEventListener("blur", onBlur);
    el.removeEventListener("keydown", onKeyDown);

    const newValue = el.innerText.trim();
    const elementId = el.id;

    // Zapis w localStorage pod dedykowanym kluczem elementu lub ogólną słownikową strukturą
    if (elementId) {
      localStorage.setItem(`span_field_${elementId}`, newValue);

      // Aktualizacja danych w obiekcie ticket, jeśli id odpowiada właściwości
      if (ticket && elementId in ticket) {
        ticket[elementId] = newValue;
      }

      let savedSpans: Record<string, string> = {};
      const existing = localStorage.getItem("savedSpanValues");
      if (existing) {
        try {
          savedSpans = JSON.parse(existing);
        } catch (e) {
          console.error("Błąd podczas parsowania savedSpanValues z localStorage:", e);
        }
      }
      savedSpans[elementId] = newValue;
      localStorage.setItem("savedSpanValues", JSON.stringify(savedSpans));
    } else {
      // Jeśli <span> nie ma ID, zapisujemy po wygenerowanym selektorze/kluczu
      const key = el.className ? `span_class_${el.className.replace(/\s+/g, "_")}` : `span_text_${el.innerText.trim().slice(0, 15).replace(/\s+/g, "_")}`;
      localStorage.setItem(key, newValue);
    }
  };

  const onKeyDown = (e: KeyboardEvent) => {
    if (e.key === "Enter") {
      e.preventDefault();
      el.blur();
    }
  };

  el.addEventListener("blur", onBlur);
  el.addEventListener("keydown", onKeyDown);
}

// Register Service Worker for PWA installability & offline support
if ("serviceWorker" in navigator) {
  registerSW({
    immediate: true,
    onNeedRefresh() {
      console.log("App update available");
    },
    onOfflineReady() {
      console.log("App ready for offline use");
    }
  });
}
